module.exports = __webpack_public_path__ + "static/media/ua_ambulance.3cdad4ca.svg";